export const stars = [
  "ASWATHY", "BHARANI", "KARTHIKA", "ROHINI", "MAKAYIRAM", "THIRUVATHIRA", 
  "PUNARTHAM", "POOYAM", "AYILYAM", "MAKAM", "POORAM", "UTHRAM", 
  "ATHAM", "CHITHIRA", "CHOTHI", "VISAKAM", "ANIZHAM", "THRIKETTA", 
  "MOOLAM", "POORADAM", "UTHRADAM", "THIRUVONAM", "AVITTAM", 
  "CHATHAYAM", "POORURUTTATHI", "UTHRUTTATHI", "REVATHI"
];
